const LAST_ACTIVITY_KEY = 'lastActivityTime';
const IDLE_FLAG_KEY = 'idle';
const IDLE_SESSION_STARTED_KEY = 'idleSessionStarted';

let idleTimeout;
let idleInterval;
let cleanupFn = null;

export const stopIdleTimer = () => {
  if (cleanupFn) {
    cleanupFn();
    cleanupFn = null;
  }
};

const getIdleMs = (idleTimeSeconds) => {
  const seconds = Number(idleTimeSeconds);
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return 600 * 1000; // default 10 minutes
  }
  return seconds * 1000;
};

export const markActivity = () => {
  localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
};

export const clearIdleSession = () => {
  localStorage.removeItem(IDLE_FLAG_KEY);
  localStorage.removeItem(LAST_ACTIVITY_KEY);
};

/** Clear previous idle state and start counting from now (call after login). */
export const startFreshIdleSession = () => {
  clearIdleSession();
  markActivity();
  try {
    sessionStorage.setItem(IDLE_SESSION_STARTED_KEY, 'true');
  } catch (e) {
    // ignore sessionStorage errors
  }
};

export const isIdleExpired = (idleTimeSeconds) => {
  if (localStorage.getItem(IDLE_FLAG_KEY)) {
    return true;
  }
  const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
  if (!lastActivity) {
    return false;
  }
  return Date.now() - lastActivity >= getIdleMs(idleTimeSeconds);
};

export const StartIdleTimer = (idleTimeSeconds, onIdleCallback, options = {}) => {
  const { freshStart = false } = options;

  if (cleanupFn) {
    cleanupFn();
    cleanupFn = null;
  }

  const idleMs = getIdleMs(idleTimeSeconds);

  if (freshStart) {
    startFreshIdleSession();
  }

  const triggerIdle = () => {
    if (window.location.pathname.includes('/login')) {
      return;
    }
    if (localStorage.getItem(IDLE_FLAG_KEY)) {
      onIdleCallback();
      return;
    }
    localStorage.setItem(IDLE_FLAG_KEY, 'true');
    onIdleCallback();
  };

  const resetTimer = () => {
    if (localStorage.getItem(IDLE_FLAG_KEY)) {
      return;
    }
    markActivity();
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(() => {
      triggerIdle();
    }, idleMs);
  };

  const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'click'];

  events.forEach((event) => window.addEventListener(event, resetTimer));

  clearInterval(idleInterval);
  idleInterval = setInterval(() => {
    if (window.location.pathname.includes("/login")) {
      return;
    }
    if (localStorage.getItem(IDLE_FLAG_KEY)) {
      return;
    }
    if (isIdleExpired(idleTimeSeconds)) {
      triggerIdle();
    }
  }, 15000);

  // Fresh login/session: always start full idle countdown from now.
  // Otherwise resume remaining time, or show expired only if truly idle.
  if (freshStart) {
    resetTimer();
  } else if (isIdleExpired(idleTimeSeconds)) {
    triggerIdle();
  } else {
    const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
    if (lastActivity) {
      const elapsed = Date.now() - lastActivity;
      const remaining = Math.max(idleMs - elapsed, 0);
      clearTimeout(idleTimeout);
      idleTimeout = setTimeout(() => {
        triggerIdle();
      }, remaining);
    } else {
      resetTimer();
    }
  }

  cleanupFn = () => {
    events.forEach((event) => window.removeEventListener(event, resetTimer));
    clearTimeout(idleTimeout);
    clearInterval(idleInterval);
  };

  return cleanupFn;
};
